import { TRoomsParams } from 'common/types/floor-params.type';

export const setSelectedRoomIdIfNeeded = ({
  calculatedRooms,
  calculatedRoomParams,
  setSelectedRoomId,
}: {
  calculatedRooms: TRoomsParams[];
  calculatedRoomParams: TRoomsParams;
  setSelectedRoomId: (valOrUpdater: string | ((currVal: string) => string)) => void;
}) => {
  if (calculatedRooms.length > 0 && calculatedRoomParams.id) {
    const roomMatch = calculatedRooms.find(({ id }) => id === calculatedRoomParams.id);
    if (roomMatch) {
      setSelectedRoomId(roomMatch.id);
    }
  }
};
